// vendor
import axios from 'axios';

// Storage Service
import storageService from '@/lib/storage-service';

// constants
import {
  LOGIN_ENDPOINT,
  REFRESH_TOKEN_ENDPOINT,
} from '@/constants/api-endpoints.constants';
import { TOKEN_EXPIRED } from '@/constants/storage.constants';

// Create an Axios instance with a base URL
const instance = axios.create({
  baseURL: import.meta.env.VITE_API_GATEWAY_BASE_URL,
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = storageService.getAccessToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;

    if (error.response?.status === 401) {
      return Promise.reject(error);
      if (originalRequest.url === LOGIN_ENDPOINT) {
        return Promise.reject(error);
      }

      // Check if the token is expired and retry flag is not set
      if (
        error.response.data.code === TOKEN_EXPIRED &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true; // Initialize `_retry` flag

        const refreshToken = storageService.getRefreshToken();
        if (!refreshToken) {
          storageService.clearToken();
          window.location.assign('/#');
          return Promise.reject(error);
        }

        try {
          const res = await instance.post(REFRESH_TOKEN_ENDPOINT, {
            refresh: refreshToken,
          });

          if (res.data?.access) {
            storageService.setAccessToken(res.data.access);
            originalRequest.headers['Authorization'] =
              'Bearer ' + res.data.access; // Set header on the original request
            return instance(originalRequest); // Retry original request
          } else {
            storageService.clearToken();
            window.location.assign('/#');
          }
        } catch (refreshError) {
          storageService.clearToken();
          window.location.assign('/#');
          return Promise.reject(refreshError); // Handle refresh error properly
        }
      } else {
        storageService.clearToken();
        window.location.assign('/#');
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
